import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

import { MeuFaturamentoRoutingModule } from './meu-faturamento-routing.module';
import { MeuFaturamentoComponent } from './meu-faturamento.component';
import { ContaService } from '../../shared/services/conta/conta.service';
import { DirectivesModule } from '../../shared/directives/directives.module';
import { FormsModule } from '@angular/forms';

import { NgxMaskModule } from 'ngx-mask';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  imports: [
    SharedModule,
    CommonModule,
    MeuFaturamentoRoutingModule,
    HttpClientModule,
    DirectivesModule,
    FormsModule,
    NgxMaskModule.forRoot()
  ],
  declarations: [
    MeuFaturamentoComponent,
  ],
  providers: [
    ContaService
  ]
})
export class MeuFaturamentoModule { }



// WEBPACK FOOTER //
// ./src/app/modules/faturamento/meu-faturamento.module.ts